import React from 'react'
import { TorchHeroSection } from './TorchHeroSection'
import { TorchWatchSection } from './TorchWatchSection'
import { WhyAngelSection } from './WhyAngelSection'

export const CreateView: React.FC = () => {
  return (
    <main className="bg-core-gray-950 pt-16 lg:pt-20">
      <TorchHeroSection />
      <TorchWatchSection />
      <WhyAngelSection />
    </main>
  )
}
